import PropTypes from 'prop-types';
import React from 'react';
import Button from '../button';
import CreatePostHandler from '../../containers/create-post-handler';
import ensureAuth from '../../hoc/ensure-auth';
import withTranslate from '../../hoc/with-translate';

const ButtonSecure = ensureAuth(Button);

const CreatePostButton = ({ t, categorySlug, isSmall }) => (
  <CreatePostHandler categorySlug={categorySlug}>
    <ButtonSecure isSmall={isSmall} data-hook="create-post">
      {t('create-post-button.create-new-post')}
    </ButtonSecure>
  </CreatePostHandler>
);

CreatePostButton.propTypes = {
  categorySlug: PropTypes.string,
  t: PropTypes.func.isRequired,
  isSmall: PropTypes.bool,
};

export default withTranslate(CreatePostButton);
